var _excluded = ["title", "required", "description", "placeholder", "fieldName", "validation", "rows", "className", "onChange", "wrapperClassName", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import GenericFormElement from '../GenericFormElement';
import { useExtendedFormikContext } from '../FormikWrapper';
import './style.scss';
var Textarea = function Textarea(props) {
  var title = props.title,
    required = props.required,
    description = props.description,
    placeholder = props.placeholder,
    fieldName = props.fieldName,
    validation = props.validation,
    rows = props.rows,
    className = props.className,
    onChange = props.onChange,
    wrapperClassName = props.wrapperClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useExtendedFormikCon = useExtendedFormikContext(),
    values = _useExtendedFormikCon.values,
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isTouched = touched[fieldName];
  var value = values[fieldName];
  var error = errors[fieldName];
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && (value === undefined || value === null || value === '')) {
      return t(['webform.components.textarea.required', 'webform.required', 'webform_required']);
    }
  };
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('Textarea', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: isTouched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator,
    errorId: errorId,
    descriptionId: descriptionId
  }, /*#__PURE__*/React.createElement(Field, _extends({}, restProps, {
    className: c(className, {
      'error': error && isTouched
    }),
    id: fieldName,
    name: fieldName,
    component: "textarea",
    value: value,
    required: required,
    placeholder: placeholder,
    rows: rows,
    validate: handleValidation,
    disabled: disabled,
    onKeyUp: function onKeyUp(event) {
      if (onChange) {
        onChange(event);
      }
    },
    "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
    "aria-invalid": Boolean(error && isTouched)
  })));
};
export default Textarea;